import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

// Managment slice if for handling state for the admin panal
export interface ManagementState {
  activeIdType: "id" | "customerId";
  queryId?: string;
}

const initialState: ManagementState = {
  activeIdType: "id",
  queryId: undefined,
};

const ManagementSlice = createSlice({
  name: "managment",
  initialState: initialState,
  reducers: {
    setIdType: (state, action: PayloadAction<"id" | "customerId">): void => {
      state.activeIdType = action.payload;
    },
    setQueryId: (state, action: PayloadAction<string>): void => {
      state.queryId = action.payload;
    },
  },
});

export const { setIdType, setQueryId } = ManagementSlice.actions; // Export the new action as well
export const useManagementState = () => useAppSelector((state) => state.managment);
export default ManagementSlice;
